import { useMemo } from "react";
const defaultAccommodationRoom = {
    adults: 2,
    children: 0,
    childrenAges: []
};
const defaultAccommodation = {
    rooms: [
        defaultAccommodationRoom
    ]
};
export const useAccommodationDefaultValue = (accommodation)=>{
    const accommodationDefaultValue = useMemo(()=>{
        if (accommodation?.rooms?.length) {
            return accommodation;
        }
        if (accommodation?.adults && accommodation?.children) {
            const { adults , children , maxChildren , maxPeople , maxRooms  } = accommodation;
            let childrenAges = [];
            if (children.value && children.defaultAge && children.value > 0) {
                for(let i = 0; i < children.value; i++){
                    childrenAges.push(children.defaultAge);
                }
            }
            return {
                adults,
                children,
                maxChildren,
                maxPeople,
                maxRooms,
                rooms: [
                    {
                        adults: adults.value ?? 1,
                        children: children.value ?? 0,
                        childrenAges
                    }
                ]
            };
        }
        return defaultAccommodation;
    }, [
        accommodation
    ]);
    return accommodationDefaultValue;
};
export default useAccommodationDefaultValue;

//# sourceMappingURL=useAccommodationDefaultValue.js.map